import { useCallback } from "react";

import {
  useRequestWithFeedback,
  type OverrideRunProps,
} from "../../../composites";
import { useLibrary } from "../../../providers";

import { API } from "./api";

import type { UserAccessibilityPreferencesPayload } from "./types";

export const useSetUserAccessibilityPreferences = () => {
  const l10n = useLibrary("translations");
  const { send, loading } =
    useRequestWithFeedback<API.UserAccessibilityPreferences>();

  const setUserAccessibilityPreferences = useCallback(
    (
      payload: UserAccessibilityPreferencesPayload,
      overrideRunProps?: OverrideRunProps<API.UserAccessibilityPreferences>,
    ) => {
      send({
        action: API.setUserAccessibilityPreferences(payload),
        messaging: {
          toast: {
            success: l10n.getString(
              "accessibility-preferences-save-success",
              null,
              "Preference saved",
            ),
            error: l10n.getString(
              "accessibility-preferences-save-error",
              null,
              "Failed to save preference",
            ),
          },
        },
        ...overrideRunProps,
      });
    },
    [l10n, send],
  );

  return { setUserAccessibilityPreferences, loading };
};
